
import './CopTable.scss';

import { GridActionsCellItem,GridColDef } from '@mui/x-data-grid'
import { JSX } from 'react';

const editSvg = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#757575">
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" />
        <path d="M20.71 7.04a1.003 1.003 0 0 0 0-1.42L18.37 3.29a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.83z" />
    </svg>
);

const deleteSvg = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#757575">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
);

type SubscriptionAction = {
    buttonType: string;
    buttonLabel: string;
    buttonUrl?: string;
};

const iconByStype: Record<string, JSX.Element> = {
    edit: editSvg,
    delete: deleteSvg,
};

export function getSubscriptionColumn(
    subscriptionActions: SubscriptionAction[] = [],
    onDeleteClick?: (id: string) => void,
    actionLabel?: string,
): GridColDef[] {
 {
    return  [
        {
            field: 'customerName',
            headerName: 'Customer Name',
            flex: 1,
            minWidth: 150,
            filterable:true
        },
        {
            field: 'customerId',
            headerName: 'Customer ID',
            flex: 0.8,
            minWidth: 130,
            filterable:true,
        },
        {
            field: 'type',
            headerName: 'Type',
            flex: 0.8,
            minWidth: 130,
            filterable:true,
        },
        {
            field: 'country',
            headerName: 'Country',
            flex: 0.7,
            minWidth: 120,
            filterable:true,
        },
        {
            field: 'customerEmailAddresses',
            headerName: 'Customer Email Address',
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <div   style={{
                    wordBreak: 'break-word',
                    alignItems: 'flex-start',
                    whiteSpace: 'normal',
                }}>
                    {params.row.customerEmailAddresses?.join(',\n')}
                </div>
            ),
        },
        {
            field: 'siteIds',
            headerName: 'Site IDs',
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <div
                    style={{
                        wordBreak: 'break-word',
                        alignItems: 'flex-start',
                        whiteSpace: 'normal',
                    }}
                >
                    {params.row.siteIds?.join(',\n')}
                </div>
            ),
        },
        {
            field: 'actions',
            headerName: actionLabel || 'Actions',
            type: 'actions',
            flex: 0.5,
            minWidth: 110,
            sortable: false,
            disableColumnMenu: true,
            getActions: (params) =>
                subscriptionActions.map((action) => (
                    <GridActionsCellItem
                        key={action.buttonType}
                        icon={iconByStype[action.buttonType] ?? editSvg}
                        label={action.buttonLabel}
                        showInMenu
                        onClick={() => {
                            if (action.buttonType === 'delete') {
                                onDeleteClick?.(String(params.row.id));
                            } else if (action.buttonUrl) {
                                window.location.href = `${action.buttonUrl}/${params.row.id}`;
                            }
                        }}
                    />
                )),
        },
    ]
} }
